<template>
  <div class="card shadow">
    <div class="card-header">
      Inventories
    </div>
    <div v-loading="loading">
      <table class="table">
        <thead class="thead-light">
          <tr>
            <th>Variant</th>
            <th>Available (Reserved)</th>
            <th>Price</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="inventory in inventories" :key="inventory.id">
            <td>
              <span v-if="inventory.product_variant">
                <router-link :to="{ name: 'products-id', params: { id: inventory.product_variant.id } }">{{ inventory.product_variant.barcode.type }} {{ inventory.product_variant.barcode.value }}</router-link><br>
                SKU {{ inventory.sku }}
              </span>
              <span v-else class="text-muted">
                <em>Unknown Product</em>
              </span>
            </td>
            <td>
              <strong>{{ inventory.stock.unreserved }}</strong> ({{ inventory.stock.reserved }})<br>
              <router-link :to="{ name: 'distributors-id', params: { id: inventory.distributor.id } }">{{ inventory.distributor.name }}</router-link>
            </td>
            <td>
              <div v-if="inventory.discount && inventory.discount.price !== 0">
                <s>{{ inventory.price.toLocaleString('en-US', { style: 'currency', currency: inventory.currency }) }}</s><br>
                <span class="text-danger">{{ inventory.discount.price.toLocaleString('en-US', { style: 'currency', currency: inventory.currency }) }}</span>
              </div>
              <div v-else>
                <span class="text-danger">{{ inventory.price.toLocaleString('en-US', { style: 'currency', currency: inventory.currency }) }}</span>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      loading: true,
      inventories: [],
    }
  },

  mounted() {
    this.getInventories()
  },

  methods: {
    async getInventories() {
      this.loading = true
      try {
        var { data } = await this.$http.get(`/inventories`)
      } catch(err) {
        this.$message.error(err.response.data.message)
        return false
      } finally {
        this.loading = false
      }

      this.inventories = data
    },
  },
}
</script>

<style>

</style>
